import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import QuestionForm from './QuestionForm';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {createQuestion} from 'api/question';
import {Link} from 'react-router-dom';
import {buildQuestionAnswerGroup, translateQuestionType} from '../../utils/common';
import {withRouter} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';


class QuestionCreation extends React.Component {
    static propTypes = {
        form: formShape,
    };

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            submitting: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showSaveFailedMessage = this.showSaveFailedMessage.bind(this);
    }

    showSaveFailedMessage() {
        const {addFlashMessage} = this.props;
        addFlashMessage('Question could not be saved. ' +
            'Please check that all required fields have been filled out');
    }

    handleSubmit(e) {
        e.preventDefault();
        const {formatErrors, addFlashMessage, form: {validateFields}, match: {params: {questionType}}} = this.props;
        const {router} = this.context;

        validateFields((error, formData) => {
            if (!isEmpty(error)) {
                this.showSaveFailedMessage();
                addFlashMessage('One or more required fields are empty');
                return;
            }

            formData['answers'] = buildQuestionAnswerGroup(formData);

            if (isEmpty(formData['answers'])) {
                const errorMessage = 'At least one question answer must be created.';
                this.setState({
                    errors: { 'Question answers': errorMessage}
                });
                this.showSaveFailedMessage();
                addFlashMessage(errorMessage);
                return;
            } else {
                const correctAnswerIndex = formData['answers'].findIndex(data => data.correct === true);
                if (correctAnswerIndex === -1) {
                    const errorMessage = 'Please select at least one correct answer';
                    this.setState({
                        errors: {'Question answers': errorMessage}
                    });
                    this.showSaveFailedMessage();
                    addFlashMessage(errorMessage);
                    return;
                }
            }
            formData['questionType'] = questionType;
            formData['supplements'] = formData.supplements.value;

            createQuestion(formData)
                .then(response => {
                    addFlashMessage('Question has been successfully created!', 'success');
                    router.history.push(`/questions/${response._id.$oid}`);
                })
                .catch(err => formatErrors(err).then(err => {
                    this.setState({
                        errors: err,
                    });
                    this.showSaveFailedMessage();
                }));
        });
    }

    render() {
        const {errors, submitting} = this.state;
        const {addFlashMessage, form, match: {params: {questionType}}} = this.props;
        return (
            <div className="content-box">
                <div className="navigation-history-container">
                    <Link to="/questions">Question Bank</Link> > Create New Question
                </div>
                <div className="section-header">
                    <h3 style={{display: 'inline'}}>
                        Question Type &nbsp;
                    </h3>
                    <Typography color="primary" style={{display: 'inline'}}>
                        {translateQuestionType[questionType]}
                    </Typography>
                </div>
                <QuestionForm {...{
                    errors,
                    form,
                    submitting,
                    onSubmit: this.handleSubmit,
                }} />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    formatErrors: (...args) => dispatch(formatErrors(...args)),
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuestionCreation.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuestionCreation)));
